import './WspBtn.css';

function WspBtn(){
    return(
        <div className='wsp-button-container'>
            <a href='https://wa.link/tfor3v' title='Contactar con un asesor' className='wsp-button-content'>
                <i class="fa-brands fa-whatsapp"></i>
            </a>
        </div>
    )
}

export default WspBtn;
